
import { EventBus, Event } from '@ps/utils/event-bus';

export default {
  components: {},
  data: function data() {
    return {
      name: '',
      orgName: '',
      onEdit: false,
      time: null,
      timeTick: null
    };
  },

  props: ['info'],
  watch: {},
  computed: {},
  filters: {
    getTextName: function getTextName(value, isDir) {
      if (isDir) {
        // 先剔除开头和结尾
        var _temp = value.slice(1, value.length - 1);
        // 目录的话要剔除中的 '/'
        var _idx = _temp.lastIndexOf('/');
        if (_idx !== -1) {
          _temp = _temp.slice(_idx + 1);
        }

        // if (temp.length > 30) {
        //   return temp.slice(0, 27) + '...'
        // }

        return _temp;
      }
      var temp = value.slice(1, value.length);
      var idx = value.lastIndexOf('/');
      temp = temp.slice(idx);

      // if (temp.length > 30) {
      //   return temp.slice(0, 27) + '...'
      // }

      return temp;
    }
  },
  methods: {
    getImgSrc: function getImgSrc() {
      return '/project/preview/' + this.$route.query.id + this.info.name.replace(/\.bin$/, '.png');
    },
    clickNameHandler: function clickNameHandler(info) {
      var _this = this;

      window.clearTimeout(this.time);
      this.time = window.setTimeout(function () {
        _this.$emit('view', info);
      }, 300);
    },
    startEditName: function startEditName(info) {
      var _this2 = this;

      window.clearTimeout(this.time);
      var tn = info.name.slice(1);
      this.name = tn.slice(tn.lastIndexOf('/') + 1);
      this.orgName = this.name;
      this.onEdit = true;
      this.$nextTick(function () {
        _this2.$refs.editEl.focus();
      });
    },
    endEditName: function endEditName() {
      var _this3 = this;

      this.onEdit = false;
      this.$nextTick(function () {
        if (_this3.name.trim() !== _this3.orgName.trim() && /^.+\.bin$/.test(_this3.name.trim())) {
          var finalName = _this3.info.name.slice(1, _this3.info.name.lastIndexOf('/') + 1) + _this3.name.trim();
          _this3.$emit('rename', _this3.info.name.slice(1), finalName);
        }
      });
    },
    rightContextmenu: function rightContextmenu(event) {
      var _this4 = this;

      this.menuList = [{
        name: '编辑预设',
        callback: function callback() {
          _this4.$emit('edit', _this4.info);
        }
      }];
      EventBus.$emit(Event.INIT_RIGHT_CONTEXT_MENU, {
        menuList: this.menuList,
        event: event
      });
    }
  }
};